import { HttpClient } from '../HttpClient';
/**
 * * Post Project Logs in My Attendance
 */
export const PostProjectLogsMyAttendance = async (postProjectLogsData) => {
  try {
    const { data } = await HttpClient.post(`api/projectLogs`, { ...postProjectLogsData });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
